module.exports = __webpack_public_path__ + "static/media/6a.36ee56ce.jpg";